import confetti from "canvas-confetti";
import { useCallback, useMemo, useRef } from "react";
import { ConfettiContext } from "./context";

const CONFETTI_DELAY_MS = 100;

function fireConfetti() {
    confetti({ particleCount: 180, spread: 90, origin: { y: 0.6 } });
}

export function ConfettiProvider({ children }: { children: React.ReactNode }) {
    const pendingRef = useRef(false);
    const openCountRef = useRef(0);
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const requestConfetti = useCallback(() => {
        if (openCountRef.current === 0) {
            fireConfetti();
        } else {
            pendingRef.current = true;
        }
    }, []);

    const setTaskOpen = useCallback((open: boolean) => {
        openCountRef.current = Math.max(0, openCountRef.current + (open ? 1 : -1));

        if (open) {
            // A task just opened — cancel any pending delayed confetti
            if (timerRef.current !== null) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        } else if (openCountRef.current === 0 && pendingRef.current) {
            pendingRef.current = false;
            timerRef.current = setTimeout(() => {
                timerRef.current = null;
                fireConfetti();
            }, CONFETTI_DELAY_MS);
        }
    }, []);

    const value = useMemo(() => ({ requestConfetti, setTaskOpen }), [requestConfetti, setTaskOpen]);

    return <ConfettiContext.Provider value={value}>{children}</ConfettiContext.Provider>;
}
